import * as React from 'react';
import classNames from 'classnames';
import * as styles from './Label.css';
import { InlineText3 } from '@cian/ui-kit';

export interface ILabelProps {
  title: string;
  bgColor: 'silver' | 'orange' | 'gray';
}

export const Label = ({ title, bgColor }: ILabelProps) => {
  return (
    <div className={classNames(styles['label'], styles[bgColor])}>
      <InlineText3>{title}</InlineText3>
    </div>
  );
};
